import { Link } from "react-router-dom";
import { BrandmarkVertical } from "@/components/Brandmark";

// Footer shared across all public pages. Vertical combination mark on the left,
// sitemap in the middle, contact / legal on the right.
export default function PublicFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-[1600px] px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <BrandmarkVertical size={140} />
            <p className="mt-4 text-sm text-slate-600 max-w-xs leading-relaxed">
              The Gantt chart that doesn't pretend tasks only have one date.
              Built for project teams who actually run projects.
            </p>
          </div>

          {/* Sitemap */}
          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-widest text-slate-500 mb-3 font-sf-label">
              Sitemap
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-slate-700 hover:text-slate-950 transition-colors" data-testid="footer-home">Home</Link></li>
              <li><Link to="/about" className="text-slate-700 hover:text-slate-950 transition-colors" data-testid="footer-about">About</Link></li>
              <li><Link to="/pricing" className="text-slate-700 hover:text-slate-950 transition-colors" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/contact" className="text-slate-700 hover:text-slate-950 transition-colors" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-widest text-slate-500 mb-3 font-sf-label">
              Legal
            </div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-slate-700 hover:text-slate-950 transition-colors" data-testid="footer-terms">Terms of Use</Link></li>
              <li>
                <Link
                  to="/contact"
                  className="text-slate-700 hover:text-slate-950 transition-colors"
                  data-testid="footer-email"
                >
                  Email us
                </Link>
              </li>
            </ul>
          </div>

          {/* Call out */}
          <div className="md:col-span-2 flex md:justify-end">
            <Link
              to="/register"
              className="inline-flex items-center h-10 px-5 rounded-full text-white text-sm font-medium tg-gradient tg-shadow-soft hover:opacity-95 transition-opacity"
              data-testid="footer-cta"
            >
              Start free
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {year} ThatGantt. Every dot of the favicon was earned in spreadsheets.</div>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-slate-950">Terms</Link>
            <span>·</span>
            <span>Made for project teams who track more than a vibe</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
